import "vue-class-component/hooks";
import "@babel/polyfill";

import Vue from "vue";
import axios from "axios";
import Chartist from 'chartist';
import CKEditor from "ckeditor4-vue";
import App from "./App.vue";
import router from "./routes/routes";
import store from "./store/";
import i18n from "@/plugins/i18n";
import MaterialDashboard from "./plugins/material-dashboard";

Vue.use(MaterialDashboard);
Vue.use(CKEditor);

Object.defineProperty(Vue.prototype, "$Chartist", {
    get() {
        return this.$root.Chartist;
    }
});

console.log(process.env);
// console.log('App version', GIT_DESCRIBE);

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
  ? process.env.VUE_APP_API_BASE_URL
  : "http://192.168.128.175/";

axios.defaults.headers.get["content-type"] = "application/json;charset=UTF-8";
axios.defaults.headers["Cache-Control"] = "no-cache";

const token = localStorage.getItem("user-token");
if (token) {
    axios.defaults.headers.common["Authorization"] = token;
}

Vue.config.productionTip = false;

Vue.config.errorHandler = (err, vm, info) => {
    if (process.env.NODE_ENV !== 'production') {
        if (err?.message !== "Cannot read properties of undefined (reading 'badInput')") {
            console.error(err);
        }
    }
};

new Vue({
    router,
    store,
    i18n,
    data: {
        Chartist: Chartist,
    },
    render: h => h(App)
}).$mount('#app');


